import { render } from "./GrantsCalendar.vue?vue&type=template&id=0560687f"
import script from "./GrantsCalendar.vue?vue&type=script&lang=js"
export * from "./GrantsCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__